import {
  BuyersStepForm,
  AddressStepForm,
  VariantListerStepForm,
  SummaryStepForm
} from './sub-forms';
import { Box } from '@mui/material';
import { Summarize } from '@mui/icons-material';
interface OrderWizardProps {
  currentStep: number;
  children: React.ReactNode;
  onBack?: () => void;
  onNext?: () => void;
}

export const OrderWizard = (props: OrderWizardProps) => {
  const { currentStep, children, onNext, onBack } = props;
  return (
    <Box
      sx={{
        py: 5,
        px: 2,
        border: '1px solid #d8d8d8',
        borderRadius: '8px'
      }}
    >
      <div>{children}</div>
      <Box
        sx={{
          py: 5,
          width: '60%'
        }}
      >
        {(() => {
          switch (currentStep) {
            case 0:
              return (
                <BuyersStepForm
                  onNext={() => onNext()}
                  onPrevious={() => onBack()}
                />
              );
            case 1:
              return (
                <AddressStepForm
                  onNext={() => onNext()}
                  onPrevious={() => onBack()}
                />
              );
            case 2:
              return (
                <VariantListerStepForm
                  onNext={() => onNext()}
                  onPrevious={() => onBack()}
                />
              );

            case 3:
              return (
                <SummaryStepForm
                  onNext={() => onNext()}
                  onPrevious={() => onBack()}
                />
              );

            default:
              return null;
          }
        })()}
      </Box>
    </Box>
  );
};
